import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-66" data-mp="1ntzwd4buliz7">
      <Reveal className="mx-auto max-w-3xl" data-id="element-67" data-mp="1nwvxf1izsnrv">
        <div className="mb-10 text-center" data-id="element-68" data-mp="2bk40dcsy7kqq">
          <p className="mb-4 font-note text-[10px] font-semibold tracking-[0.24em] text-sage sm:text-xs" data-id="element-69" data-mp="2bmgrafgop5fx">
            BUONO A SAPERSI
          </p>
          <h2 className="text-3xl font-bold tracking-tight text-petrol md:text-4xl" data-id="element-70" data-mp="21vccbfr0dkl3">Domande frequenti</h2>
        </div>
        <div className="space-y-3" data-id="element-71" data-mp="26scirrrrspcq">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-xl border border-line bg-white shadow-soft" data-id="element-72" data-mp="2zbhspir3ngbp" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-heading text-sm font-semibold text-petrol transition-colors duration-150 ease-out hover:bg-sand/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-sage md:text-base" data-id="element-73" data-mp="1vq15awz0nhxw">
                  <span data-id="element-74" data-mp="2oe6m58my8msg">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-sage" aria-hidden="true" data-id="element-75" data-mp="2occbcn5e6b23" /> : <PlusIcon className="h-5 w-5 shrink-0 text-sage" aria-hidden="true" data-id="element-76" data-mp="u0ficprawx4x" />}
                </button>
                <AnimatePresence initial={false} data-id="element-77" data-mp="p24a2jgnmuot">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-78" data-mp="2p3u24qdxw8tq">
                      <p className="px-6 pb-6 text-sm leading-relaxed text-muted" data-id="element-79" data-mp="382g221xpztw2">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}